import { defineComponent as _defineComponent } from 'vue';
import { Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import _debounce from 'lodash/debounce';
import { useListNestedGeographiesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Geography',
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var _useListNestedGeograp = useListNestedGeographiesQuery({
        filters: {
          id: 280
        }
      }),
      result = _useListNestedGeograp.result;
    var normalizer = function normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: node.children
      };
    };
    var attrs = useAttrs();
    var debouncedEmit = _debounce(function (event, value) {
      emit(event, value);
    }, 100);
    var onInput = function onInput(val) {
      var comparator = function comparator(a, b) {
        return a == b;
      };
      if (attrs.multiple) {
        comparator = function comparator(a, b) {
          return _.isEqual(_.sortBy(a), _.sortBy(b));
        };
      }
      if (!comparator(attrs.value, val)) {
        debouncedEmit('input', val);
      }
    };
    var options = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listGeographies) || [];
    });
    var patchedValue = computed(function () {
      // we patch the value to prevent from showing "undefined - undefine" because <treeselect expect :value="null" for invalid value
      // we might need a better one if we have valid value of empty string: ''

      if (attrs.value === '' || !attrs.value) {
        return null;
      }
      return attrs.value;
    });
    return {
      __sfc: true,
      result: result,
      normalizer: normalizer,
      emit: emit,
      attrs: attrs,
      debouncedEmit: debouncedEmit,
      onInput: onInput,
      options: options,
      patchedValue: patchedValue,
      Treeselect: Treeselect
    };
  }
});